import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { performFullLogout } from 'utils/auth/auth';

const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    performFullLogout(dispatch);
    navigate('/login');
  }, [navigate, dispatch]);

  return null;
};

export default Logout;
